import React from 'react';
import { ChevronDownIcon as ArrowIcon } from '@heroicons/react/24/solid';
import { classnames } from '@/utils/classnames/classnames';
import { useAccordion } from '../../context';
import { Props } from './types';

const AccordionButton = ({
  children,
  className = '',
  defaultSpacing = true,
  withArrow = true,
  density = 'default',
  chevronTone = 'gray',
  invertChevron = false,
}: React.PropsWithChildren<Props>) => {
  const { isExpanded, toggle } = useAccordion();

  // EWM-480 — base icon is a down-chevron. Default: rotate when expanded
  // (down-collapsed → up-expanded). Inverted: rotate when collapsed
  // (up-collapsed → down-expanded).
  const arrowClassName = classnames(
    'shrink-0',
    chevronTone === 'primary' ? 'text-primary' : 'text-gray-700',
    (invertChevron ? !isExpanded : isExpanded) ? 'rotate-180' : '',
  );

  return (
    <button
      className={classnames(
        'flex w-full cursor-pointer items-center gap-2',
        {
          'px-4 py-[18px]': defaultSpacing && density === 'default',
          'px-6 py-5': defaultSpacing && density === 'spacious',
        },
        className,
      )}
      onClick={toggle}
    >
      <div className="grow text-start">{children}</div>
      {withArrow && <ArrowIcon data-testid="arrow-icon" width={24} className={arrowClassName} />}
    </button>
  );
};

export default AccordionButton;
